import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";


const CohortNameComponent = (props) => {
  return (
    <div className="cohortsec1" style={styles.container}>
      <div style={{ width: "20vw", margin: "auto", textAlign: "center" }}>
        <Box sx={{ marginBottom: "200px" }}>
          <p style={styles.label}>
            Cohort Name <span style={{ color: "red" }}>*</span>
          </p>
          <TextField
            fullWidth
            id="cohort-name"
            label="Enter Cohort Name"
            variant="standard"
            name="cohortname"
            autoComplete="off"
            value={props.cohortName}
            onChange={props.handleCohortNameChange}
            sx={{
              "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" }, 
              "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" }, 
            }}
          />
          {props.errors.cohortName && (
            <p style={{ color: "red", textAlign: "left", marginTop: "8px" }}>
              {props.errors.cohortName}
            </p>
          )}
        </Box>

      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#fff",
     borderRadius:"24px"
    
  },
  label: {
    fontSize: "28px",
    fontWeight: 500,
   textAlign:"left"
  },
  button: {
    backgroundColor: "#14AE78",
    color: "#fff",
    width: "100px",
    height: "40px",
    marginTop: "40px",
   
    
  },

};

export default CohortNameComponent;
